<template lang="pug">
transition(name="el-zoom-in-top")
  .content-wrapper
    <!-- Main content -->
    section.content
      .box.citic-box
        el-tabs(v-model="curTabs", @tab-click="handleClick")
          el-tab-pane(label="待下载", name="new")
            //- el-button.download(
            //-   type="primary",
            //-   @click="handleDownUnloadAll()"
            //- ) 下载全部
            .list
              el-table(
                :data="newList",
                style="width:100%;margin-bottom: 20px;",
                border
              ) 
                //- el-table-column(type="expand" @click="getListdetail()")
                //-   template(slot-scope="scope")
                //-     detail(:id="scope.row.id")
                el-table-column(
                  prop="factory_qc_name",
                  label="厂商全称",
                  width="200"
                )
                el-table-column(prop="factory_short_name", label="厂商简称")
                el-table-column(prop="explainnum", label="线索数量")
                el-table-column(
                  prop="operationtime",
                  label="最后报名时间",
                  width="180"
                )
                el-table-column(prop="admin_name", label="管理员姓名")
                el-table-column(prop="admin_phone", label="管理员手机")
                el-table-column(prop="admin_email", label="管理员邮箱", width="250")
                el-table-column(
                  label="查看详情",
                  width="100",
                  @click="getListdetail(scope.row)"
                )
                  template(slot-scope="scope")
                    button(@click="unloadList(scope.row)") 查看详情
                el-table-column(label="下载")
                  template(slot-scope="scope")
                    el-button(
                      type="primary",
                      @click="handleDownUnloadAll(scope.row)"
                    ) 下载
            .table-list__footer
              el-pagination(
                @current-change="handlePageChangeOne",
                :current-page="currentPage.one",
                :page-size="page_size",
                layout="total, prev, pager, next, jumper",
                :total="totalOne"
              )

          el-tab-pane(label="已下载", name="downloaded")
            //- el-button.download(
            //-   type="primary",
            //-   @click="handleDownloadAll(scope.row)"
            //- ) 下载全部
            .list
              el-table(
                :data="alreadyList",
                style="width:100%;margin-bottom: 20px;",
                border
              ) 
                el-table-column(
                  prop="factory_qc_name",
                  label="厂商全称",
                  width="200"
                )
                el-table-column(prop="factory_short_name", label="厂商简称")
                el-table-column(prop="explainnum", label="线索数量")
                el-table-column(
                  prop="operationtime",
                  label="最后报名时间",
                  width="180"
                )
                el-table-column(prop="admin_name", label="管理员姓名")
                el-table-column(prop="admin_phone", label="管理员手机")
                el-table-column(prop="admin_email", label="管理员邮箱", width="250")
                el-table-column(
                  label="查看详情",
                  width="100",
                  @click="getListAlreadydetail(scope.row)"
                )
                  template(slot-scope="scope")
                    button(@click="loadedList(scope.row)") 查看详情
                el-table-column(label="下载" prop="repeat_commodity_id")
                  template(slot-scope="scope")
                    el-button(
                      type="primary",
                      @click="handleDownloadAll(scope.row)"
                    ) 下载

            .table-list__footer
              el-pagination(
                @current-change="handlePageChangeTwo",
                :current-page="currentPage.two",
                :page-size="page_size",
                layout="total, prev, pager, next, jumper",
                :total="totalTwo"
              )
</template>

<script>
import axios from 'axios'
import detail from './detail'
export default {
  components: {
    detail
  },
  data () {
    return {
      currentPage: {
        one: 0,
        two: 0
      },
      totalOne: 0,
      totalTwo: 0,
      curTabs: 'new',
      newList: null,
      alreadyList: null,
      detailList: [],
      enterprise_account_id: 1,
      detaulList: null
    }
  },
  methods: {
    // 页面分页
    handlePageChangeOne (page) {
      this.currentPage.one = page
      this.getListNew()
    },
    handlePageChangeTwo (page) {
      this.currentPage.two = page
      this.getListAlready()
    },
    // tab切换
    handleClick (tab, event) {
      console.log('curTabs', this.curTabs)
      if (this.curTabs === 'new') {
        this.getListNew()
      } else {
        this.getListAlready()
      }
    },
    // 未下载查看详情
    unloadList (scope) {
      this.$router.push(`sales/unload/detail/${scope.id}`)
      // this.getListdetail(scope)
    },
    // 已下载查看详情
    loadedList (scope) {
      this.$router.push(`sales/loaded/detail/${scope.id}`)
      // this.getListdetail(scope)
    },
    // 获取未下载的详情
    async getListdetail (scope) {
      let url = this.$config.API.sales.listNewByAccount
      axios.get(url, {
        params: {
          page: this.currentPage.one,
          enterprise_account_id: scope.id
        }
      }).then(res => {
        console.log('res.data', res.data)
        this.unloadDetailList = res.data.data.applyexplainList
        console.log('unloadDetailList', this.unloadDetailList)
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 获取已下载的详情
    async getListAlreadydetail (scope) {
      let url = this.$config.API.sales.listByAccount
      axios.get(url, {
        params: {
          page: this.currentPage.two,
          enterprise_account_id: scope.id
        }
      }).then(res => {
        console.log('res.data', res.data)
        this.detailList = res.data.data.applyexplainList
        console.log('detailList', this.detailList)
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 获取文件名
    getFileName () {
      let str = '选型宝企业账号所带来的销售线索'
      let date = new Date()
      return `${str}_${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}.xls`
    },
    // 未下载
    async handleDownUnloadAll (scope) {
      let fileName = this.getFileName()
      let data = {
        enterprise_account_id: scope.id
      }
      let url = this.$config.API.sales.downloadNewByAccount + `?enterprise_account_id=${data.enterprise_account_id}`
      axios.post(url, data, {
        responseType: 'blob'
      }).then(res => {
        if (res.status === 200) {
          const url = URL.createObjectURL(new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 已下载
    async handleDownloadAll (scope) {
      let fileName = this.getFileName()
      let data = {
        enterprise_account_id: scope.id
      }
      let url = this.$config.API.sales.downloadByAccount
      axios.post(url, data, {
        responseType: 'blob'
      }).then(res => {
        if (res.status === 200) {
          const url = URL.createObjectURL(new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取未下载的列表
    async getListNew () {
      let params = {
        page: this.currentPage.one
      }
      console.log('new')
      try {
        let list = await this.requests.salesListNew(params)
        console.log('list', list)
        this.newList = list.data.data.applyexplainList
        this.totalOne = list.data.TOTAL_NUM
      } catch (err) {
        this.$message.error(err)
      }
    },
    // 获取已下载列表
    async getListAlready () {
      let params = {
        page: this.currentPage.two
      }
      console.log('get')
      try {
        let list = await this.requests.salesListDownloaded(params)
        console.log('list', list)
        this.alreadyList = list.data.data.applyexplainList
        this.totalTwo = list.data.TOTAL_NUM
      } catch (err) {
        this.$message.error(err)
      }
    }
  },
  mounted () {
    this.getListNew()
    this.getListAlready()
    console.log('requests', this.requests)
  }
}
</script>
<style lang="scss">
.download {
  position: absolute;
  top: 10px;
  right: 30px;
}
</style>


// WEBPACK FOOTER //
// home.vue?206fcc72